module.exports = __webpack_public_path__ + "img/sectigo-trust-logo.aaf0e341.png";